/* tslint:disable */
/* eslint-disable */
/**
 * Datenbankgestalter.de API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * describes the unit that the product or additional is being handled in
 * @export
 */
export const Unit = {
    Piece: 'PIECE',
    YearlySubscription: 'YEARLY_SUBSCRIPTION',
    MonthlySubscription: 'MONTHLY_SUBSCRIPTION',
    Month: 'MONTH',
    Year: 'YEAR',
    Hour: 'HOUR',
    Voucher: 'VOUCHER',
    Refund: 'REFUND'
} as const;
export type Unit = typeof Unit[keyof typeof Unit];


export function UnitFromJSON(json: any): Unit {
    return UnitFromJSONTyped(json, false);
}

export function UnitFromJSONTyped(json: any, ignoreDiscriminator: boolean): Unit {
    return json as Unit;
}

export function UnitToJSON(value?: Unit | null): any {
    return value as any;
}

